import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { ContactInfo } from "model";

/**
 * @class NotificationHistory
 * @classdesc Class definition for record type from model
 * @param {OBJECT} record - record from the model to init class
 * @extends BCMSRecord
 * @example const notification = new NotificationHistory(model.notificationHistory[0]);
 * 
 * @property {NUMBER} _id - The id of the notification history
 * @property {STRING} _name - The name of the notification history
 * @property {bcmsDate} _date - The date of the notification history
 * @property {contactInfo} _contactInfo - The contact info related to the notification history
 * @property {STRING} _icon - The icon of the notification history
 */
export default class NotificationHistory extends BCMSRecord {
    _id;
    _name;
    _date;
    _contactInfo;
    _icon;

    constructor(record) {
        super(record);
    }
}

NotificationHistory.define({
    "recordType" : "notificationHistory",
    "recordIDProp" : "id",
    "className" : "NotificationHistory",
    "recordProperties" : [
        /**
         * @name
         * @instance
         * @property get {NUMBER} - gets the id of the notification history
         * @property set {NUMBER} - sets the id of the notification history
         * @memberof NotificationHistory
         */
        BCMSRecordProperty.mapToNumber("id", "_id"),

        /**
         * @name
         * @instance
         * @property get {STRING} - gets the name of the notification history
         * @property set {STRING} - sets the name of the notification history
         * @memberof NotificationHistory
         */
        BCMSRecordProperty.mapToString("name", "_name"),

        /**
         * @name
         * @instance
         * @property get {bcmsDate} - gets the date of the notification history
         * @property set {bcmsDate} - sets the date of the notification history
         * @memberof NotificationHistory
         */
        BCMSRecordProperty.mapToDate("date", "_date"),

        /**
         * @name
         * @instance
         * @property get {contactInfo} - gets the contact info of the notification history
         * @property set {contactInfo} - sets the contact info of the notification history
         * @memberof NotificationHistory
         */
        BCMSRecordProperty.mapToClass("contactInfo", "_contactInfo", () => ContactInfo, "contactInfoID"),

        /**
         * @name
         * @instance
         * @property get {STRING} - gets the icon of the notification history
         * @property set {STRING} - sets the icon of the notification history
         * @memberof NotificationHistory
         */
        BCMSRecordProperty.mapToString("icon", "_icon")
    ]
});